import { BaseComponent } from '@cinch-nx/data-storyblok'
import { SvgIcon, Text } from '@cinch-labs/design-system'
import styles from './offer-card.module.css'
import Image from 'next/image'

interface OfferCardProps extends BaseComponent {
  component: 'OfferCard'
  imageSrc: string
  banner: string
  title: string
  offerDetails: string[]
  footerText: string
}

export const OfferCard = ({
  imageSrc,
  banner,
  title,
  offerDetails,
  footerText,
}: OfferCardProps) => (
  <div className={styles.container}>
    <div className={styles.headSection}>
      <div className={styles.imageContainer}>
        <Image
          src={imageSrc}
          alt={''}
          fill={true}
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
        />
      </div>
      <div className={styles.banner}>
        <Text className={styles.banner}>{banner}</Text>
      </div>
    </div>
    <div className={styles.infoSection}>
      <Text className={styles.title}>{title}</Text>
      <div>
        {offerDetails.map((detail, index) => (
          <div key={index} className={styles.bulletPoint}>
            <SvgIcon name={'tick'} size={16} />
            <Text className={styles.text}>{detail}</Text>
          </div>
        ))}
      </div>
      <Text className={styles.footerText}>{footerText}</Text>
    </div>
  </div>
)
